import { createContext } from "react";

export const NotificationBadgeContext = createContext(null);
